export default {
  tab: {
    allExchanges: 'Toàn Thị Trường',
    hose: 'HOSE',
    hnx: 'HNX',
    upcom: 'UPCOM',
  },
  typeTab: {
    marketCap: 'VỐN HÓA',
    volume: 'KHỐI LƯỢNG',
    value: 'GIÁ TRỊ',
    buyVol: 'KLNN MUA',
    sellVol: 'KLNN BÁN',
    bulVal: 'GTNN MUA',
    sellVal: 'GTNN BÁN',
  },
  noData: 'Không Có Dữ Liệu',
  ticker: 'MÃ',
  price: 'GIÁ',
  percentChange: '% THAY ĐỔI',
  marketCap: 'VỐN HÓA (TỶ)',
  volume: 'KHỐI LƯỢNG',
  value: 'GIÁ TRỊ',
  frBuyVol: 'KLNN MUA',
  frSellVol: 'KLNN BÁN',
  frBuyVal: 'GTNN MUA',
  frSellVal: 'GTNN BÁN',
};
